export class FiltroDenuncias {
  constructor(
    fechaInicialPeriodo = null,
    fechaFinalPeriodo = null,
    textoDeBusqueda = ""
  ) {
    (this.fechaInicialPeriodo = fechaInicialPeriodo),
      (this.fechaFinalPeriodo = fechaFinalPeriodo);
    this.textoDeBusqueda = textoDeBusqueda;
  }
  cargarDatosParaFormulario(args) {
      if (args.includes("administrar-denuncias")) {
        const date = new Date();
      this.fechaInicialPeriodo = new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDay() - 15
      )
        .toISOString()
        .split("T")[0];
      this.fechaFinalPeriodo = new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDay() + 15
      )
        .toISOString()
        .split("T")[0];
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/SIFA/Comun/Modelos/Filtros/FiltroDenuncias.js